import { ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { Component } from "@angular/core";

@Component({
  standalone: false,
    selector: "app-reports",
    templateUrl: "./reports.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./reports.component.scss"],
})
export class ReportsComponent {
    graphLoaded = false;

    constructor(private cdr: ChangeDetectorRef) {}

    onGraphReady(isReady: boolean) {
        this.graphLoaded = isReady;
        this.cdr.detectChanges();
    }

    public onPrint() {
        window.print();
    }
}
